import { render, staticRenderFns } from "./ResidentialTerraceHouse.vue?vue&type=template&id=5b908fc4&scoped=true&"
import script from "./ResidentialTerraceHouse.vue?vue&type=script&lang=ts&"
export * from "./ResidentialTerraceHouse.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialTerraceHouse.vue?vue&type=style&index=0&id=5b908fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b908fc4",
  null
  
)

export default component.exports